import { FontAwesome5 } from '@expo/vector-icons';
import {
  secondaryFontFamily,
  styled,
  ThemeType,
} from '@openeducation/oe-rn-themes';
import { rgba } from 'polished';
import React, { memo } from 'react';

import { OEText } from '../oe-text/oe-text';

export interface BadgeProps {
  text: string;
  color: string;
  fontSize: number;
  value?: number;
  check?: boolean;
}

export const Badge = ({
  text,
  color,
  value,
  fontSize = 12,
  check,
}: BadgeProps) => {
  const renderLeftComponent = () => {
    if (check) {
      return <FontAwesome5 color={color} name="check" size={fontSize * 0.9} />;
    }

    if (value) {
      return (
        <Value color={color} fontSize={fontSize + 2}>
          {value}
        </Value>
      );
    }

    return <Dot color={color} size={fontSize / 2} />;
  };

  return (
    <Container color={color}>
      {renderLeftComponent()}
      <BadgeText fontSize={fontSize} lineHeight={fontSize + 4}>
        {text}
      </BadgeText>
    </Container>
  );
};

type CommonType = {
  color: string;
  theme: ThemeType;
};

const Container = styled.View<CommonType>`
  padding: 4px 8px;
  flex-direction: row;
  align-items: center;
  align-self: flex-start;
  background-color: ${({ color }) => rgba(color, 0.1)};
  border-radius: 2px;
`;

const Value = styled(OEText).attrs(({ color }) => ({
  color,
  fontFamily: secondaryFontFamily,
  fontType: 'bold',
}))<CommonType>`
  padding-right: 3px;
`;

type DotType = {
  size: number;
  color: string;
};

const Dot = styled.View<DotType>`
  background-color: ${({ color }) => color};
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: ${({ size }) => size / 2}px;
`;

const BadgeText = styled(OEText).attrs(({ theme }) => ({
  color: theme.color.black,
  fontFamily: secondaryFontFamily,
  fontType: 'medium',
}))`
  padding-left: 4px;
`;

export default memo(Badge);
